import React from 'react';
import ReactDOM from 'react-dom';
import { useDispatch } from 'react-redux';
import classNames from 'classnames';

import { closeModal } from 'features/order-tracker/store/actions';

import styles from './styles.module.scss';


export const CommonModal: React.FC<sharedComponents.CommonModal> = ({
  isOpened,
  hasCloseBtn,
  parentSelector,
  className,
  children,
}) => {
  const dispatch = useDispatch();
  const parentContainer = (parentSelector && document.querySelector(parentSelector)) || document.body;

  const content = isOpened && (
    <div className={styles.overlay}>
      <div className={styles.notificationBox}>
        <div className={classNames(styles.content, className)}>
          { children }
          {hasCloseBtn && (
            <button
              className={styles.close}
              onClick={() => dispatch(closeModal())}
              type="button"
            >
              close
            </button>
          )}
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(content, parentContainer);
};
